<style scoped>
    .pu_rule_msg {
        display: block;
        font-size: 12px;
    }

    div.placeholder {
        width: 100%;
        height: 0;
        background: #f7f7f7;
        position: relative;
    }

    img.placeholded-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }

    /*.multiple-images::after {*/
    /*    content: '';*/
    /*    display: block;*/
    /*    position: absolute;*/
    /*    left: 0;*/
    /*    top: 0;*/
    /*    width: 100%;*/
    /*    height: 100%;*/
    /*    background: linear-gradient(rgba(0, 0, 0, 0.5) 0%, transparent 10%);*/
    /*}*/
</style>


<template>
    <div>
        <transition name="fade">
            <div :key="'resource_dark'" class="pu_dark" v-if="$store.getters.currentProduct"
                 v-show="$store.getters.modal.resource"></div>
        </transition>
        <transition name="slide">
            <div :key="'resource'" class="pu_bottom popup_click_hide" v-if="$store.getters.currentProduct"
                 v-show="$store.getters.modal.resource">
                <div class="pu_bottom_scroll">
                    <div @click="close()" class="pu_b_close"></div>
                    <div class="pu_bottom_inner scroll_y"
                         :class="{'full-height': this.$store.getters.container === this.$store.getters.const.CONTAINER_IFRAME}"
                         :ref="'scrollContainer'">
                        <div class="pu_tovar">
                            <div class="pu_tovar_name">
                                {{ $store.getters.currentProduct.name }}
                            </div>
                            <div class="pu_tovar_text"
                                 v-html="renderDescription($store.getters.currentProduct.description)">
                            </div>
                            <Datepicker :times="$store.getters.currentProduct.times"
                                        :periods="$store.getters.currentProduct.periods"
                                        :pickedPeriod.sync="pickedPeriod"/>
                        </div>
                        <div class="pu_tovar_nav">
                            <div class="pu_tovar_nav_btn"
                                 :class="{
                              'pu_tovar_nav_btn_disable': addNew && (!pickedPeriod || pickedPeriod.start === null || pickedPeriod.end === null),
                              'pu_tovar_nav_btn_none': !addNew && (!pickedPeriod || pickedPeriod.start === null || pickedPeriod.end === null),
                            }">
                                <a class="fbb_btn" @click="addToBasket">
                                    {{ button }}<i v-html="$options.filters.toCurrency(countPrice)" :class="{'ios-font': $store.getters.checkIos}"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
  import { mapGetters } from 'vuex'
  import * as moment from 'moment'

  const marked = require('marked')
  import Slick from 'vue-slick'
  import '@/assets/css/slick.css'
  import { ADD_TO_BASKET, UPDATE_BASKET } from '@/store/actions.type'
  import { SET_MODAL } from '@/store/mutations.type'
  import Datepicker from '@/components/Default/Resource/Datepicker'

  const renderer = {
    code(code, infostring, escaped) {
      return '<p>' + code + '</p>'
    }
  }

  marked.use({ renderer })

  export default {
    name: 'Resource',
    components: {
      Datepicker
    },
    data() {
      return {
        loaded: false,
        alreadySelected: false,
        pickedPeriod: {
          start: null,
          end: null
        }
      }
    },
    mounted() {
      this.loadCurrentProduct()

      this.$store.subscribe(mutation => {
        if (mutation.type === SET_MODAL && mutation.payload.modal === 'resource') {
          if (mutation.payload.status === true) {
            this.alreadySelected = false
            this.loaded = false
            this.count = 1
            this.loadCurrentProduct()
          } else {
            if (this.$refs.scrollContainer) {
              this.$refs.scrollContainer.scrollTo(0, 0)
            }
          }
        }
      })
    },

    methods: {
      renderDescription(description) {
        let sku = ''
        if (this.$store.getters.currentProduct.sku) {
          sku = '<span class="sku">' + this.$store.getters.currentProduct.sku + '</span>'
        }
        return marked(this.$options.filters.nl2br(description)) + sku
      },

      loadCurrentProduct() {
        if (this.loaded) {
          return
        }

        this.pickedPeriod = { start: null, end: null }
        let currentProduct = this.$store.getters.currentProduct
        let selectedProducts = this.$store.getters.selectedProducts

        if (!currentProduct) {
          return
        }

        for (let i = 0; i < selectedProducts.length; i++) {
          const product = selectedProducts[i]
          if (currentProduct.basket_item_id && product.basket_item_id === currentProduct.basket_item_id) {
            this.alreadySelected = true
            if (!this.addNew) {
              this.pickedPeriod.start = new Date(product.from)
              this.pickedPeriod.end = new Date(product.to)
            }
          }
        }
      },

      async addToBasket() {
        if (this.addNew && (!this.pickedPeriod || !this.pickedPeriod.start || !this.pickedPeriod.end)) {
          return this.close()
        }

        const currentProduct = this.$store.getters.currentProduct

        let payload = {
          basketItemId: currentProduct.basket_item_id,
          resourceId: currentProduct.id,
          pickedPeriod: {
            start: this.pickedPeriod.start ? moment(this.pickedPeriod.start).format('YYYY-MM-DD HH:mm:ss') : null,
            end: this.pickedPeriod.end ? moment(this.pickedPeriod.end).format('YYYY-MM-DD HH:mm:ss') : null
          },
        }

        if (this.addNew) {
          await this.$store.dispatch(ADD_TO_BASKET, payload)
        } else {
          await this.$store.dispatch(UPDATE_BASKET, payload)
        }

        this.close()
      },

      close() {
        this.$store.commit(SET_MODAL, { modal: 'resource', status: false })
      },

    },
    computed: {

      countPrice() {
        let price = 0

        if (!this.pickedPeriod || !this.pickedPeriod.start || !this.pickedPeriod.end) {
          return price
        }

        let date = moment(this.pickedPeriod.start.toString()).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0)
        while (date <= this.pickedPeriod.end) {
          for (let i in this.$store.getters.currentProduct.periods) {
            if (
              moment(this.$store.getters.currentProduct.periods[i].date_start).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0) <= date &&
              moment(this.$store.getters.currentProduct.periods[i].date_end).utcOffset(this.$store.getters.outletSettings.timezone_offset).hour(0) >= date
            ) {
              price += this.$store.getters.currentProduct.periods[i].price
            }
          }
          date.add(1, 'd')
        }
        return price
      },

      addNew() {
        return this.$route.name !== 'receipt'
        // let basketItemId = null
        // for (let i = 0; i < this.$store.getters.selectedProducts.length; i++) {
        //   if (this.$store.getters.selectedProducts[i].id === this.$store.getters.currentProduct.id) {
        //     basketItemId = this.$store.getters.selectedProducts[i].basket_item_id
        //     break
        //   }
        // }
        // return !basketItemId
      },

      button() {
        if (!this.addNew && this.alreadySelected) {
          if (!this.pickedPeriod || !this.pickedPeriod.start || !this.pickedPeriod.end) {
            return this.text('product_remove')
          } else {
            return this.text('product_save')
          }
        } else {
          if (!this.pickedPeriod || !this.pickedPeriod.start || !this.pickedPeriod.end) {
            return this.text('clear_basket_cancel')
          } else {
            return this.text('product_add')
          }
        }
      },
    },
  }
</script>
